module.exports = __webpack_public_path__ + "img/bulle-euro-contours-verts.svg";